/* eslint-disable react/prop-types */
import { DateFormat, dateFormat } from '@cp/src/utils/DateHelper';
import styles from './index.module.scss';
import { Typography } from '@navi/web-ui/lib/primitives';
interface DateTimeProps {
  istDate?: Date;
}

const DateTime: React.FC<DateTimeProps> = ({ istDate }) => {
  const dateValue = istDate ? dateFormat(istDate, DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME) : '';
  const timeValue = istDate ? dateFormat(istDate, DateFormat.HH_mm_ampm) : '';
  return (
    <div>
      <Typography variant="h4" className={styles.dateValue}>
        {dateValue}
      </Typography>
      <Typography variant="h4" className={styles.timeValue}>
        {timeValue}
      </Typography>
    </div>
  );
};

export default DateTime;
